<template>
  <div class="nx-tags">
    <ul class="tags-box nx-no-scrollbar">
      <li v-for="(item,index) in tagsList" :key="index" class="tag nx-flex-align-center">
        <!-- <nx-image :is-oss="false" :src="require('@/assets/images/icon/associated.png')" width="12px" height="13px"></nx-image> -->
        <span class="nx-change-active-color"># {{ item.name ? item.name : item }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NxTags',
  props: {
    tagsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.nx-tags{
  .tags-box{
    margin-top: 14px;
    // padding-left: 18px;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    .tag{
      margin-right: 7px;
      padding: 4px 6px;
      background: $text-active-bg-change;
      border-radius: 2px;
      font-size: 12px;
      font-weight: 500;
      color: $text-active-color-change;
      line-height: 12px;
      white-space:nowrap;
      border-radius: 20px;
      span{
        margin-left: 4px;
      }
    }
  }
}
</style>
